import React from 'react'
import Navbar from '../../Components/Navbar'
import Suplychainheader from '../../Components/Suplychainheader'
import Logistics from '../../Components/Logistics'
import Footer from '../../Components/Footer'

const Supply = () => {
  return (
    <div>
      <Navbar/>
      <Suplychainheader/>
      <Logistics/>
      <Footer/>
      
    </div>
  )
}

export default Supply
